import { useMemo } from 'react';
import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { SMSNumberV1 } from '@frontend/api-sms-number';
import { formatPhoneNumberE164 } from '@frontend/phone-numbers';
import { useAppScopeStore } from '@frontend/scope';

export const useValidPhoneNumberFromPerson = (locationId: string | undefined, person: Person | undefined) => {
  const { selectedLocationIds } = useAppScopeStore();
  const { validPhones } = SMSNumberV1.Hooks.usePersonSMSNumbersValidity({
    personId: person?.personId ?? '',
    person,
    groupIds: locationId ? [locationId] : selectedLocationIds,
  });

  const firstValidPhoneNumber = useMemo(() => {
    let firstValidPhoneNumber: string | undefined;

    if (validPhones.length > 0) {
      const isPersonPhoneNumberValid = !!validPhones.find(
        (validity) =>
          formatPhoneNumberE164(validity.number) ===
          formatPhoneNumberE164(
            person?.contactInfo?.find((contact) => contact.type.toLowerCase().includes('phone'))?.destination ?? ''
          )
      );
      firstValidPhoneNumber = isPersonPhoneNumberValid
        ? person?.contactInfo?.find((contact) => contact.type.toLowerCase().includes('phone'))?.destination
        : validPhones[0]?.number;
    }
    return firstValidPhoneNumber;
  }, [person?.contactInfo, JSON.stringify(validPhones)]);

  return { firstValidPhoneNumber };
};
